module.exports = __webpack_public_path__ + "kacirek4-8-prany.jpg?576704edb8a0bc421207fcd826dc82aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/kacirek4-8-prany.jpg
// module id = 80
// module chunks = 0